import ErrorHandler from 'common/error/components/error-handler';
import SidePanel from 'common/side-panel/side-panel';
import Spinner from 'common/spinner/components/spinner';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Div } from 'ui';
import * as styles from './create-order.css';
import NavContextItem from './nav-context-item';
import OrdersTable from './orders-table';
import SimplifiedCreateOrderForm from './simplified-create-order-form';

const Title = styled.div`
  display: flex;
  width: 100%;
`;

const SectionTitle = styled.h3`
  font-weight: bold;
  text-transform: uppercase;
  display: flex;
  flex-flow: row nowrap;
  line-height: 30px;
`;

const Step = styled.div`
  width: 30px;
  height: 30px;
  background-color: ${p => p.theme.colors.theme};
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 10px;
`;

const CreateOrderSidepanel = ({
  progressLabel,
  goToDashboard,
  error,
  isLoading,
  scheduledItems,
  isSubmitting,
  intl,
  navContext,
  handleSelectedScheduleSubmit,
  createOrder,
  id,
  ticketActionId,
  type,
}) => {
  const handleSubmit = (values) => {
    createOrder({
      ...values,
      id,
      type,
      ticketActionId,
      indicator: values.businessIndicator || values.paymentType,
      isSimplified: true,
      paidByValue: values.contractNumber || values.costCenter || values.assetNumber,
    });
  };

  return (
    <SidePanel
      title={
        <Title>
          <Div flex={1}>{intl.formatMessage({ id: 'orderWizard.TITLE' })}</Div>
          {progressLabel}
        </Title>
      }
      width='60%'
      onPanelClose={goToDashboard}
    >
      <ErrorHandler type='notification' error={error} />
      {isLoading ?
        <Spinner title={intl.formatMessage({ id: 'orderWizard.MSG_LOADING' })} />
        :
        <div className={styles.createOrder}>
          <section className={styles.navContext}>
            {navContext?.map(item =>
              <NavContextItem key={item.type} item={item} />,
            )}
          </section>
          <div className={styles.divider} />
          <section>
            <SectionTitle>
              <Step>A</Step>
              <div>{intl.formatMessage({ id: 'orderWizard.simplified.SCHEDULED' })}</div>
            </SectionTitle>
            <OrdersTable
              orders={scheduledItems}
              onSubmit={handleSelectedScheduleSubmit}
              isSubmitting={isSubmitting}
            />
            <div className={styles.divider} />
          </section>
          <section>
            <SectionTitle>
              <Step>B</Step>
              <div>{intl.formatMessage({ id: 'orderWizard.simplified.NEW' })}</div>
            </SectionTitle>
            <SimplifiedCreateOrderForm
              isLoading={isLoading}
              isSubmitting={isSubmitting}
              cancel={goToDashboard}
              handleSubmit={handleSubmit}
            />
          </section>
        </div>
      }
    </SidePanel>
  );
};
CreateOrderSidepanel.propTypes = {
  progressLabel: PropTypes.string,
  goToDashboard: PropTypes.func,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  scheduledItems: PropTypes.array,
  isSubmitting: PropTypes.bool,
  intl: PropTypes.object,
  navContext: PropTypes.object,
  handleSelectedScheduleSubmit: PropTypes.func,
  createOrder: PropTypes.func,
  id: PropTypes.string,
  ticketActionId: PropTypes.string,
  type: PropTypes.string,
};

export default injectIntl(CreateOrderSidepanel);
